import {PqmFieldEmpty} from "./PqmFieldEmpty";
import {BasePqmFieldValue} from "./BasePqmFieldValue";

export class PqmFieldRegister {
	static registeredPqmFieldClass: Record<string, typeof BasePqmFieldValue> = {};
	static register(inputFieldClass: typeof BasePqmFieldValue) {
		for(const k of inputFieldClass.getValueTypes())
			PqmFieldRegister.registeredPqmFieldClass[k] = inputFieldClass;
	}

	static getClassFor(paramType: string, control: string): (typeof BasePqmFieldValue)|null
	{
		if (!paramType) return null;
		const k1 = paramType + ":" + control;
		const k2 = paramType + ":*";
		return PqmFieldRegister.registeredPqmFieldClass[k1]
			|| PqmFieldRegister.registeredPqmFieldClass[k2]
			|| PqmFieldEmpty;
	}

}